<template>
  <DetailDeviceLayout @tabCb="tabCb" :deviceId="deviceId">
    <template #action-slot>
      <component :is="action" :deviceId="$route.params.deviceId" @eventSensorData="eventSensorData" />
    </template>
    <template #body-slot>
      <component :is="currentComp" v-bind="bindProps"></component>
    </template>
    <template #footer-slot>
      <p v-if="action != 'sensorDeviceAction'" class="pagination-detail">
        {{display}}
      </p>
      <pagination-comp @prev="prev" @next="next" :page="page" :totalPage="totalPage" v-if="action != 'sensorDeviceAction'" />
    </template>
  </DetailDeviceLayout>
</template>

<script>
import DetailDeviceLayout from "../layout/DetailDeviceLayout.vue";
import PaginationComp from "../elements/PaginationComp.vue";
import EventBus from '@/plugins/EventBus';

export default {
  props: {
    deviceId: {
      required: true,
    },
  },
  components: {
    DetailDeviceLayout,
    sensorDeviceComp: () => import("../elements/SensorDeviceComp.vue"),
    sensorRecordComp: () => import("../elements/SensorRecordComp.vue"),
    sensorDeviceAction: () => import("../elements/SensorDeviceAction.vue"),
    sensorRecordAction: () => import("../elements/SensorRecordAction.vue"),
    PaginationComp,
  },
  methods: {
    createAction() {
      this.deviceFormTitle = "Create Sensor";
      this.deviceFormBtnTitle = "Save";
      this.deviceFormShowed = true;
      this.editForm = false;
    },
    editAction() {
      this.deviceFormTitle = "Edit Sensor";
      this.deviceFormBtnTitle = "Save";
      this.deviceFormShowed = true;
      this.editForm = true;
    },
    deleteAction() {
      this.deleteDeviceShowed = true;
    },
    tabCb(data) {
      this.page = 1;
      this.totalPage = 0;
      this.currentComp =
        data == "sensor" ? "sensorDeviceComp" : "sensorRecordComp";
      this.action =
        data == "sensor" ? "sensorDeviceAction" : "sensorRecordAction";
    },
    eventSensorData(){
      this.loadSensor();
    },
    loadSensor(){
     const devices = this.$store.getters.getCurrentDevice;
    if (devices.length == 0) {
      this.$router.push("/dashboard");
      return;
    }
    const device = devices
      .filter((d) => d.deviceId == this.$route.params.deviceId)
      .at(0);
    this.sensors = device.sensorResponses;
    },
    prev(){
      if(this.page <= 1) return;
      EventBus.$emit("sensorPagination", this.page-1)
    },
    next(){
      if(this.page >= this.totalPage) return;
      EventBus.$emit("sensorPagination", this.page+1)
    },
    setPagination(data){
      this.page = data.record.page;
      this.totalPage = data.record.totalPage;
      if(data.record.totalPage <= 0){
        this.display = "";
      }else{
        this.display = `Display page ${data.record.page} of ${data.record.totalPage}`
      }
    }
  },
  data() {
    return {
      action: "sensorDeviceAction",
      currentComp: "sensorDeviceComp",
      deviceFormTitle: "Create Sensor",
      deviceFormBtnTitle: "Create",
      deviceFormShowed: false,
      deleteDeviceShowed: false,
      editForm: false,
      display: "",
      totalPage: 0,
      page: 1,

      sensors: [],
    };
  },
  computed: {
    bindProps() {
      return this.currentComp == "sensorDeviceComp"
        ? { sensors: this.sensors, deviceId: this.deviceId }
        : {deviceId: this.deviceId, page: this.page};
    },
  },
  created() {
    EventBus.$on("sensorData", this.setPagination)
    this.loadSensor();
  },
  destroyed(){
    EventBus.$off("sensorData", this.setPagination)
  }
};
</script>
